import { LogService, MySquid, onConfigChange, PostVidaDeInfluencer, VidaDeInfluencerService } from '@hub/shared'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { SubscriptionLike } from 'rxjs'
import CardInfluencerLife from '../card-influencer-life/card-influencer-life.component'
import './influencers-life.component.scoped.scss'
import { SqLoader } from '@squidit/react-css'

export default () => {
  const onConfigChangeSubscription = useRef<SubscriptionLike | undefined | null>(undefined)
  const squidCommunityService = useMemo(() => new VidaDeInfluencerService(), [])
  const logService = useMemo(() => new LogService(), [])
  logService.init('SectionList Component')

  const [isLoading, setIsLoading] = useState(false)
  const [config, setConfig] = useState<MySquid | null>(null)
  const [cards, setCards] = useState<PostVidaDeInfluencer[]>([])

  const getArticles = useCallback(async () => {
    setIsLoading(true)
    squidCommunityService
      ?.getPosts({})
      .then(({ response: { data } }) => {
        setCards(data?.content)
      })
      .catch((error) => {
        logService.error({ message: 'Error on get articles', error })
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [logService, squidCommunityService])

  useEffect(() => {
    onConfigChangeSubscription.current = onConfigChange.subscribe((configChanged: MySquid | any) => {
      if (configChanged?._id) {
        setConfig(configChanged)
      } else {
        getArticles()
      }
    })
    return () => {
      onConfigChangeSubscription.current?.unsubscribe()
    }
  }, [onConfigChangeSubscription, getArticles])

  if (config?._id) {
    return null
  }

  if (isLoading) {
    return (
      <div className="text-center py-3" style={{ width: '100%' }}>
        <SqLoader size="big" />
      </div>
    )
  }

  return (
    <div className="section-list">
      <main className="list-cards">
        {cards?.map((card: any, index) => (
          <CardInfluencerLife card={card} key={`card-influencer-${index}`} />
        ))}
      </main>
    </div>
  )
}
